import { NgModule } from '@angular/core'; 
import { RouterModule, Routes } from '@angular/router'; 
import { HomeComponent } from './Layout/home.component';  
import { HospitalDocVerificationComponent } from './Document Verification/hospital-doc-verification/hospital-doc-verification.component'; 
import { SchoolDocVerificationComponent } from './Document Verification/school-doc-verification/school-doc-verification.component'; 
import { StudentFeesComponent } from './School/Business/student-fees/student-fees.component';

import { SocietyDocVerificationComponent } from './Document Verification/society-doc-verification/society-doc-verification.component'; 
import { AuthGuard } from './Guards/auth.guard'; 
import { WelcomePageComponent } from './Layout/welcome-page/welcome-page.component'; 
import { RoundupOffTransactionComponent } from './PayLater/round-off-transaction/round-off-transaction.component'; 
import { LoginComponent } from './login/login.component'; 
import { UrlBasedSignupPageComponent } from './url-based-signup-page/url-based-signup-page.component'; 
import { UrlBasedResetPasswordPageComponent } from './url-based-reset-password-page/url-based-reset-password-page.component'; 
import { NoauthLayoutComponent } from './noauth-layout/noauth-layout.component'; 
import { ListingDetailComponent } from './real-estate/BackOffice/listing/listing-detail/listing-detail.component'; 
import { PropertyFormPageComponent } from './real-estate/BackOffice/property-form-page/property-form-page.component'; 
import { UListingComponent } from './real-estate/EndUser/u-listing/u-listing.component'; 
import { PageNotFoundComponent } from './Layout/page-not-found/page-not-found.component'; 
import { PaymentOptionsComponent } from './PayLater/payment-options/payment-options.component'; 
import { LoanApplicationMasterComponent } from './PayLater/loan-application-master/loan-application-master.component'; 
import { UrlBasedLoginPageComponent } from './url-based-login-page/url-based-login-page.component'; 
import { MenuMasterComponent } from './hospital/BackOffice/hospital-master/menu-master/menu-master.component'; 
import { EndUserBbpsComponent } from './BBPS/end-user-bbps/end-user-bbps.component'; 
import { PatientConcentComponent } from './hospital/BackOffice/hospital-master/hospital-detail/hospital-patient-master/patient-concent/patient-concent.component'; 
import { GenerateCertificateComponent } from './Common/Generate_Certificate/generate-certificate/generate-certificate.component'; 
import { ServiceAvailabiltyComponent } from './Common/Service_Availabilty/service-availabilty/service-availabilty.component'; 
import { ItemCategoryComponent } from './Inventory/item-category/item-category.component'; 
import { SocietyAttendenceManangementComponent } from './housing-society/society-attendence-manangement/society-attendence-manangement.component'; 
import { ConfigurationComponent } from './real-estate/BackOffice/configuration/configuration.component'; 
import { ModuleConfigComponent } from './Common/module-config/module-config.component'; 
import { RolesModuleComponent } from './Common/roles-module/roles-module.component'; 
import { MenumasterModuleComponent } from './Common/menumaster-module/menumaster-module.component'; 
import { SubroleModuleComponent } from './Common/subrole-module/subrole-module.component'; 
import { UsermenuConfigComponent } from './Common/usermenu-config/usermenu-config.component';
import { CrmComponent } from './CRM/crm/crm.component';
import { ConfigComponent } from './CRM/config/config.component';
import { EntityComponent } from './CRM/entity/entity.component';
import { InviteComponent } from './housing-society/BackOffice/invite/invite.component';
import { FeedbackTabComponent } from './School/EndUser/feedback-tab/feedback-tab.component';
import { HospitalRaiseTicketComponent } from './Common/RaiseTicket/hospital-raise-ticket/hospital-raise-ticket/hospital-raise-ticket.component';
import { SelfOnboardingComponent } from './Common/self-onboarding/self-onboarding.component';
import { InvoiceDetailComponent } from './hospital/BackOffice/hospital-master/invoice-detail/invoice-detail.component';
// import { StudentFeesComponent } from './School/Business/student-fees/student-fees.component';
 
 
const routes: Routes = [ 
 
  // { path: '', redirectTo: 'login', pathMatch: 'full' }, 
  { path: 'login', component: UrlBasedLoginPageComponent, title: 'Login - Nishwik' }, 
  { path: 'signup', component: UrlBasedSignupPageComponent, title: 'SignUp - Nishwik'  }, 
  { path: 'reset-password/:id', component: UrlBasedResetPasswordPageComponent, title: 'Reset Password - Nishwik' }, 
 
  {path: 'hospital-document-upload/:sessionId/:hospitalId', component: HospitalDocVerificationComponent, title: 'Hospital Document Upload'}, 
  {path: 'school-document-upload/:sessionId/:schoolId', component: SchoolDocVerificationComponent, title: 'School Document Upload'}, 
  {path: 'society-document-upload/:sessionId/:societyId', component: SocietyDocVerificationComponent , title: 'Society Document Upload'}, 
  { path: "patient-consent/:mappingId", component: PatientConcentComponent, title: "Patient Consent", pathMatch: "full" },
  { path: "self-onboarding/:module/:entityNameWithId", component: SelfOnboardingComponent, title: "Self Onboarding", pathMatch: "full"},

 
  //Paylater page routes 
  { path: 'payment', component: PaymentOptionsComponent, title: 'Pay-Now' }, 
  { path: 'quick-loan', component: LoanApplicationMasterComponent, title: "Quick Loan Application"}, 
 
 
  { path: 'PageNotFound', component: PageNotFoundComponent, title: 'Page Not Found'}, 
  { 
    path: '', component: HomeComponent, title: 'Nishwik', canActivate: [AuthGuard], children: [ 
      { path: '', component: WelcomePageComponent, title: 'Nishwik'}, 
      { path: 'myaccount', loadChildren: () => import('./master/master.module').then(m => m.MasterModule) }, 
      { path: 'bbps', loadChildren: () => import('./BBPS/bbps.module').then(m => m.BbpsModule), title: 'BBPS' }, 
      { path: 'real-estate', loadChildren: () => import('./real-estate/real-estate.module').then(m => m.RealEstateModule) }, 
      { path: 'paylater', loadChildren: () => import('./PayLater/paylater-services.module').then(m => m.PayLaterServicesModule) }, 
 
      { path: 'loan-leads', loadChildren: () => import('./loan-lead/loan-lead.module').then(m => m.LoanLeadModule) }, 
 
      // school parent routes 
      { path: 'school', loadChildren: () => import('./School/school.module').then(m => m.SchoolModule), title: 'School' }, 
      { path: 'school-admin', loadChildren: () => import('./School/school.module').then(m => m.SchoolModule), title: 'School' }, 
      { path: 'school-owner', loadChildren: () => import('./School/school.module').then(m => m.SchoolModule), title: 'School' }, 
      { path: 'school-parent', loadChildren: () => import('./School/school.module').then(m => m.SchoolModule), title: 'School' }, 
      { path: 'school-student', loadChildren: () => import('./School/school.module').then(m => m.SchoolModule), title: 'School' }, 
      { path: 'school-teacher', loadChildren: () => import('./School/school.module').then(m => m.SchoolModule), title: 'School' }, 
      { path: 'school-non-teaching', loadChildren: () => import('./School/school.module').then(m => m.SchoolModule), title: 'School' }, 
      { path: 'school-driver', loadChildren: () => import('./School/school.module').then(m => m.SchoolModule), title: 'School' }, 
      { path: 'school-principal', loadChildren: () => import('./School/school.module').then(m => m.SchoolModule), title: 'School' }, 
 
      { path: 'housing-society', loadChildren: () => import('./housing-society/housing-society.module').then(m => m.HousingSocietyModule), title: 'Housing Society' }, 
      { path: 'hospital', loadChildren: () => import('./hospital/hospital.module').then(m => m.HospitalModule), title: 'Hospital' }, 
      { path: 'smartvault', component: RoundupOffTransactionComponent, title: 'Smart Vault' }, 
      { path: 'invest', loadChildren: () => import('./investment/investment.module').then(m => m.InvestmentModule), title: 'Invest' }, 
      { path: 'menuMaster', component:MenuMasterComponent , title :"Menu Master"}, 
      { path: 'generate-certificate', component: GenerateCertificateComponent, title: 'Generate Certificate'}, 
      { path: 'service-availability', component: ServiceAvailabiltyComponent, title: 'Service Availability'}, 
      { path: 'hm-inventory',  loadChildren: () => import('./Inventory/inventory.module').then(m => m.InventoryModule), title: 'Inventory'} ,
      { path: 'crm', loadChildren: () =>  import('./CRM/crm.module').then(m => m.CrmModule), title: "CRM" },
      // { path: 'user-menu-config', component: UsermenuConfigComponent, title: 'User-Menu-Config'}, 
      
     
      {
  path: 'feedback/:schoolid',
  component: FeedbackTabComponent,
  title: 'Feedback'
},

{
  path: 'feedback',
  component: FeedbackTabComponent,
  title: 'Feedback'
},

// DB SubRoleCode compatibility
{
  path: 'spe-feedback',
  component: FeedbackTabComponent,
  title: 'Feedback'
},


{
  path: 'raiseticket',
  component: HospitalRaiseTicketComponent,
  title: 'Raise Ticket'
},

// DB SubRoleCode compatibility
{
  path: 'spe-raiseticket',
  component: HospitalRaiseTicketComponent,
  title: 'Raise Ticket'
},
{ path: 'fee', component: StudentFeesComponent, title: 'Student Fees' },
      { 
    path: 'fee',
     component: StudentFeesComponent,
     title: 'Fee'
      },

      {
        path: 'module-config',
        children: [

          {
            path: '',
            redirectTo: 'roles',
            pathMatch: 'full'
          },

          {
            path: 'roles',
            component: RolesModuleComponent,
            title: 'Roles'
          },

          {
            path: 'menu-master',
            component: MenumasterModuleComponent,
            title: 'Menu Master'
          },

          {
            path: 'sub-roles',
            component: SubroleModuleComponent,
            title: 'Sub Roles'
          },

          { path: 'user-menu-config', 
            component: UsermenuConfigComponent, 
            title: 'User-Menu-Config'
          },
           {
            //  canActivate:[SocietyAuthGuard],
             path:'sm-society-invite',
             component:InviteComponent,
             title:'Invite'
            },
            {
              //  canActivate:[SchoolAuthGuard],
               path:'hm-hospital-invite',
               component:InviteComponent,
               title:'Invite'
              },
          // =====================================================
          // EXISTING LEGACY ROUTES
          // KEEP THESE WORKING
          // =====================================================

          {
            path: 'module-config-roles',
            redirectTo: 'roles',
            pathMatch: 'full'
          },

          {
            path: 'module-config-menu-master',
            redirectTo: 'menu-master',
            pathMatch: 'full'
          },

          {
            path: 'module-config-sub-roles',
            redirectTo: 'sub-roles',
            pathMatch: 'full'
          },

          {
            path: 'user-menu-config',
            redirectTo: 'sub-roles',
            pathMatch: 'full'
          }

          
        ]
      },

      { path: 'end-user-bbps', component:EndUserBbpsComponent , title:"BBPS"}, 
      // { path: 'end-user-bbps', loadChildren: () => import('./BBPS/bbps.module').then(m => m.BbpsModule), title: 'BBPS' }, 
    ] 
  }, 
 
  { 
    path: 'home', component: NoauthLayoutComponent, title: 'Nishwik', children: [ 
      // { path: '', redirectTo: 'login', pathMatch: 'full' }, 
      { path: 'listing', component: UListingComponent }, 
      { path: 'listing/:id', component: ListingDetailComponent }, 
      { path: 'listing/pty-form', component: PropertyFormPageComponent, title: 'Listing Form' } 
    ] 
  }, 

  { 
    path: 'policy', 
    loadChildren: () => import('./policy/policy.module').then(m => m.PolicyModule) 
  }, 
 
  {  
    path: 'school-document-upload/:token', 
    component: SchoolDocVerificationComponent, 
    title: 'School Document Upload' 
  }, 

  // Temporary: keep until token-based backend flow is fully working. 
  {  
    path: 'school-document-upload/:sessionId/:schoolId', 
    component: SchoolDocVerificationComponent, 
    title: 'School Document Upload' 
  }, 
 
 
 
 
  { 
    path:'item-category', 
    component:ItemCategoryComponent, 
    title:'Item Category' 
  } ,

 
]; 
 
 
@NgModule({ 
  imports: [RouterModule.forRoot(routes)], 
  exports: [RouterModule], 
 
}) 
export class AppRoutingModule { 
 
}